/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

export default {
    HOME_title: "Tableau de bord",
    HOME_collectedThisMonth: "Encaissé ce mois",
    HOME_collectedLastMonth: "Encaissé le mois dernier",
    HOME_collectedTotal: "Total encaissé",
    HOME_mrr: "Revenu mensuel récurrent",
    HOME_activeCustomers: "Clients actifs",
    HOME_activeCustomersHint: "Abonnement payant en cours",
    HOME_activeUsers: "Utilisateurs actifs",
    HOME_activeUsersHint: "Des clients à abonnement payant en cours",
    HOME_freeSubscriptions: "Abonnements gratuits",
    HOME_freeSubscriptionsHint: "Actifs, à 0 €",
    HOME_mrrGap: "Écart avec les abonnements de la Console : {0}",
    HOME_mrrFromConsole: "Calculé sur la Console : Stripe ne répond pas",
    HOME_failedPayments: "Échecs de paiement",
    HOME_topCustomers: "Meilleurs clients",
    HOME_topCustomersHint: "Toutes les périodes, TTC",
    HOME_failed: "Échoué",
    HOME_newThisMonth: "{0} nouveaux ce mois",
    HOME_activeSubscriptions: "Abonnements actifs",
    HOME_revenue12Months: "Revenu encaissé — 12 derniers mois",
    HOME_topProducts: "Top produits",
    HOME_subscriptionsByStatus: "Abonnements par statut",
    HOME_vsLastMonth: "vs mois dernier",
    HOME_noData: "Aucune donnée pour le moment",
    HOME_metric_Collected: "Volume encaissé",
    HOME_metric_NewCustomers: "Nouveaux clients payants",
    HOME_metric_NewSubscriptions: "Nouveaux abonnements",
    HOME_metric_MRR: "Revenu mensuel récurrent",
    HOME_metric_PayingSubscribers: "Abonnés payants",
    HOME_metric_AverageRevenue: "Revenu moyen par abonné",
    HOME_metric_Cancellations: "Annulations",
    HOME_previousPeriod: "période précédente",
    HOME_subscriptionsByPlan: "Abonnements par plan",
    HOME_mrrByRecurrence: "Revenu récurrent mensuel / annuel",
    HOME_recurrenceMonthly: "Mensuel",
    HOME_recurrenceYearly: "Annuel",
    HOME_dateRange: "Plage de dates",
    HOME_compare: "Comparer",
    HOME_rangeToday: "Aujourd'hui",
    HOME_rangeLast7Days: "7 derniers jours",
    HOME_rangeLast4Weeks: "4 dernières semaines",
    HOME_rangeLast6Months: "6 derniers mois",
    HOME_rangeLast12Months: "12 derniers mois",
    HOME_rangeCurrentMonth: "Mois en cours",
    HOME_rangeCurrentQuarter: "Trimestre en cours",
    HOME_rangeYearToDate: "Année en cours",
    HOME_rangeAllTime: "Toutes les périodes",
    HOME_rangeStart: "Début",
    HOME_rangeEnd: "Fin",
    HOME_rangeClear: "Effacer",
    HOME_rangeApply: "Appliquer",
    HOME_granularityDay: "Par jour",
    HOME_granularityWeek: "Par semaine",
    HOME_granularityMonth: "Par mois",
    HOME_comparePrevious: "Période précédente",
    HOME_compareYear: "Année précédente",
    HOME_subscriptionsSuffix: "abonnements"
};
